import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { SessionSummarySelector } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";

@Component({
	selector: "obg-m-session-limit-expired-alert",
	templateUrl: "./session-limit-expired-alert.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SessionLimitExpiredAlertContainer {
	sessionSummary$ = this.store.select(SessionSummarySelector.get);

	constructor(
		@Inject(MAT_DIALOG_DATA) public nextTimeLogin: string | undefined,
		private store: Store<CoreContentState>
	) {}
}
